import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mt-4 w-full" }
const _hoisted_2 = { class: "mt-1 flex flex-col gap-y-2" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src", "srcset"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "block text-sm font-medium tracking-[0.1px] text-parameter-title" }
const _hoisted_7 = { class: "block truncate text-xs leading-[15px] text-parameter-text" }
const _hoisted_8 = { class: "block truncate text-xs leading-[15px] text-parameter-text" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]

import ItemV3RemoveGroupModal from "@/components/itemV3/parameter/itemV3RemoveGroupModal.vue";
import {computed, inject, ref, watch} from "vue";
import {useI18n} from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'itemV3StonesList',
  props: {
    stoneGroups: {},
    activeGroupIdx: { default: -1 }
  },
  emits: ["patch", "update:activeGroupIdx", "groups"],
  setup(__props: any, { emit: __emit }) {


const {t} = useI18n();

const emit = __emit;

const props = __props;

const itemIdx = inject<any>("itemIdx");
const session = inject<any>("session");

/**
 * stone groups
 *
 * Transferred from itemV3Grooves.vue's "grooves" computed: scans the current item's
 * variants for idx patterns "stones.<n>.<attr>" (ignoring the "add"/"remove" actions)
 * and groups them by <n> into one object per stone group.
 */

const stoneGroupList = computed(() => Object.values(props.stoneGroups))

const hasStoneGroups = computed(() => Object.keys(props.stoneGroups).length > 0)

// Let the parent (itemV3Stones.vue) know about the current stone groups, so it can
// build the "stone group list switch-button bar" and render the matching details.
watch(stoneGroupList, (value) => {
  emit('groups', value)
}, {immediate: true, deep: true})

/**
 * images
 */

const getStoneGroupLayoutImageUrl = (layoutType: string, size: 300 | 600 = 600) => {
  return `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/stone_layout/${size}/${layoutType}.webp`
}

/**
 * group title
 *
 * The group title is related to the group's stoneLayout (e.g. "Steinreihe #1",
 * "Sternenhimmel #3") - each layout has its own text stored in de.json, falling back
 * to the generic "Stein-Gruppe #n" text when the layout has no dedicated entry.
 */

const stoneGroupNameTypes = ["single", "row", "crown", "starry_sky"]

const getStoneGroupTitle = (group: any) => {
  const key = stoneGroupNameTypes.includes(group.stone_layout) ? group.stone_layout : "default"
  return t('components.parameters.stoneGroupNames.' + key, {n: group.group_idx + 1})
}

/**
 * select / edit a stone group
 */

const selectStoneGroup = (groupIdx: number) => {
  emit('update:activeGroupIdx', groupIdx)
}

/**
 * Patch
 */

const handleValuePatch = (actionIdx: string, value: any) => {
  value = (typeof value == "string") ? value : value.idx
  emit('patch', {
    action: actionIdx,
    value: value,
    certificated_diamond: value.certificated_diamond
  });
};

/**
 * remove stone group
 */

const showRemoveModal = ref(false)
const stoneGroupToRemove = ref<any>(null)

const confirmRemoveStoneGroup = (group: any) => {
  stoneGroupToRemove.value = group
  showRemoveModal.value = true
};

const stoneGroupToRemoveName = computed(() => {
  return stoneGroupToRemove.value ? getStoneGroupTitle(stoneGroupToRemove.value) : ''
})

const handleRemoveStoneGroup = () => {
  if (stoneGroupToRemove.value) {
    handleValuePatch(`stones.${stoneGroupToRemove.value.group_idx}.remove`, 'remove')
    if (props.activeGroupIdx === stoneGroupToRemove.value.group_idx) {
      emit('update:activeGroupIdx', -1)
    }
  }
  showRemoveModal.value = false
  stoneGroupToRemove.value = null
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("ul", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.stoneGroups, (group, groupKey) => {
          return (_openBlock(), _createElementBlock("li", {
            key: 'stone-group-' + groupKey,
            class: _normalizeClass(["flex items-center gap-3 rounded-2xl p-2 transition-colors hover:bg-[#f3f0e9] bg-white border cursor-pointer", __props.activeGroupIdx === group.group_idx ? 'border-brand-main bg-[#f3f0e9]' : 'border-gray-200'])
          }, [
            _createElementVNode("span", {
              class: "flex size-14 shrink-0 items-center justify-center overflow-hidden rounded-2xl border border-[#e7ddcc] bg-[#f8f5ee]",
              onClick: ($event: any) => (selectStoneGroup(group.group_idx))
            }, [
              _createElementVNode("img", {
                src: getStoneGroupLayoutImageUrl(group.stone_layout, 300),
                srcset: getStoneGroupLayoutImageUrl(group.stone_layout, 600),
                class: "w-full h-full object-cover",
                alt: ""
              }, null, 8, _hoisted_4)
            ], 8, _hoisted_3),
            _createElementVNode("div", {
              class: "min-w-0 flex-1",
              onClick: ($event: any) => (selectStoneGroup(group.group_idx))
            }, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(getStoneGroupTitle(group)), 1),
              _createElementVNode("span", _hoisted_7, _toDisplayString(group.stone_setting), 1),
              _createElementVNode("span", _hoisted_8, _toDisplayString(group.stone_size) + " " + _toDisplayString(group.stone_quality), 1)
            ], 8, _hoisted_5),
            _createElementVNode("button", {
              type: "button",
              class: "flex size-8 shrink-0 items-center justify-center rounded-full text-[#8f8a80] transition-colors hover:bg-white hover:text-brand-main",
              title: "Bearbeiten",
              onClick: ($event: any) => (selectStoneGroup(group.group_idx))
            }, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "size-3.5",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("path", { d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" }),
                _createElementVNode("path", { d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4Z" })
              ], -1)
            ]))], 8, _hoisted_9),
            _createElementVNode("button", {
              type: "button",
              class: "flex size-8 shrink-0 items-center justify-center rounded-full text-[#8f8a80] transition-colors hover:bg-white hover:text-red-500",
              title: "Entfernen",
              onClick: ($event: any) => (confirmRemoveStoneGroup(group))
            }, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "size-3.5",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("polyline", { points: "3 6 5 6 21 6" }),
                _createElementVNode("path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" })
              ], -1)
            ]))], 8, _hoisted_10)
          ], 2))
        }), 128))
      ])
    ]),
    _createVNode(ItemV3RemoveGroupModal, {
      modelValue: showRemoveModal.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showRemoveModal).value = $event)),
      "item-name": stoneGroupToRemoveName.value,
      onConfirm: handleRemoveStoneGroup
    }, null, 8, ["modelValue", "item-name"])
  ], 64))
}
}

})